<template>
  <div class="login-conter-bg">
    <div class="login-bg">
      <svg-icon icon-class="login_icon"></svg-icon>
    </div>
    <div class="login-info">
      <van-cell-group :border="false">
        <van-field :border="false" :center="true" v-model="phone" placeholder="请输入手机号">
          <template #left-icon>
            <svg-icon icon-class="login_phone"></svg-icon>
          </template>
        </van-field>
        <van-field maxlength="6" v-model="code" :center="true" clearable placeholder="请输入短信验证码">
          <template #left-icon>
            <svg-icon icon-class="login_left_code"></svg-icon>
          </template>
          <template #button>
            <div class="login-code-button" @click.prevent="sendCode">
              <svg-icon icon-class="login_code"></svg-icon>
              <p>{{message}}</p>
            </div>
          </template>
        </van-field>
      </van-cell-group>
    </div>
    <div class="login-button" @click.prevent="login">
      <svg-icon icon-class="login_button" />
      <p>登录</p>
    </div>
    <div class="login_bottom">
      <van-checkbox v-model="checked" icon-size="15px" checked-color="#fc6e09">登录即代表同意</van-checkbox>
      <p @click="checkProtocol">《服务协议》</p>
      <p @click="checkLicense">《信息授权协议》</p>
    </div>
    <van-popup
      v-model="showProtocol"
      :closeable="true"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <div class="protocol-content">
        服务协议
        <service-agreement></service-agreement>
      </div>
    </van-popup>
    <van-popup
      v-model="showLicense"
      :closeable="true"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <div class="protocol-content">
        授权协议
        <license-agreement></license-agreement>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import URL from "@/api/api";
import { UrlSearch, setLocal, setSession } from '@/utils/utils'
import serviceAgreement from '../../view/login/serviceAgreement.vue';
import LicenseAgreement from '../../view/login/licenseAgreement.vue';
export default {
  components: { serviceAgreement, LicenseAgreement },
  data() {
    return {
      phone: "",
      code: "",
      count: 0,
      timer: null,
      message: "获取验证码",
      checked: false,
      showProtocol: false,
      showLicense: false,

    };
  },
  mounted() {
    let phone = sessionStorage.getItem("phone");
    if (phone) {
      this.phone = phone;
    }
  },
  methods: {
    login() {
      setSession("phone", this.phone);
      let data = {
        openid: localStorage.getItem("openid"),
        phoneNo: this.phone,
        verifyCode: this.code,
        appCode: UrlSearch().appCode,
        userKey: UrlSearch().userKey
      };
      let phoneNo = /^1[3456789]\d{9}$/;
      if (this.phone == "") {
        Toast("请输入手机号");
      } else if (!phoneNo.test(this.phone)) {
        Toast("手机号格式不正确");
      } else if (this.code == "") {
        Toast("请输入短信验证码");
      } else if (!this.checked) {
        Toast("请勾选下方协议");
      } else {
        this.$fetchPost(URL.login.url, data).then((res) => {
          if (res.data.code == 20000) {
            this.$router.replace({ path: '/sasabank', query: { appCode: UrlSearch().appCode ,userKey: UrlSearch().userKey} });
          } else {
            Toast(res.data.msg)
          }
        });
      }
    },
    sendCode() {
      this.message = "发送中...";
      let data = {
        type: 5,
        phoneNumber: this.phone,
      };
      let phoneNo = /^1[3456789]\d{9}$/;
      if (!phoneNo.test(this.phone)) {
        Toast("请输入正确手机号");
      } else {
        this.$fetchGet(URL.sendCode.url, data).then((res) => {
          if (!this.timer) {
            this.count = 60;
            this.timer = setInterval(() => {
              if (this.count >= 0 && this.count <= 60) {
                this.message = this.count-- + " " + "s";
              } else {
                this.message = "获取";
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        });
      }
    },
    checkProtocol() {
      this.showProtocol = true
    },
    checkLicense() {
      this.showLicense = true
    },

  },
}
</script>

<style lang="less" scoped>
.login-conter-bg {
  height: 100vh;
  background: #fff;
}
.login-bg {
  width: 375px;
  height: 203.5px;
  text-align: center;
  background: url("../../view/login/img/bg.png") no-repeat 100%;
  background-size: 100% 100%;
  .svg-icon {
    width: 141px;
    height: 132px;
    margin-top: 32.5px;
  }
}
.login-info {
  width: 355px;
  margin: auto;
  margin-top: 8px;
  overflow: hidden;
  .van-cell {
    height: 46px;
    background: transparent;
    border-bottom: 1px solid #ededed;
    margin-top: 38px;
    padding: 10px 0 18px 0;
    /deep/.van-field__left-icon {
      margin-right: 18px;
    }
  }
  .svg-icon {
    width: 20.8px;
    height: 30.13px;
  }
  .login-code-button {
    position: relative;
    width: 1.94667rem;
    height: 0.74667rem;
    .svg-icon {
      width: 73px;
      height: 28px;
      background-position: center;
    }
    p {
      width: 100%;
      text-align: center;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      font-size: 12px;
      font-weight: Regular;
      font-family: PingFang SC;
      color: #fc6e09;
    }
  }
}
.login-button {
  width: 272.5px;
  height: 42px;
  margin: 65px auto 0 auto;
  position: relative;
  .svg-icon {
    height: 42px;
  }
  p {
    width: 272.5px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    font-size: 15px;
    color: #ffffff;
  }
}
.login_bottom {
  // width: 200px;
  height: 15.5px;
  line-height: 15.5px;
  display: flex;
  font-size: 12px;
  margin: 84.5px auto auto 50px;
  // /deep/.van-checkbox__icon .van-icon {
  //   width: 15px;
  //   height: 15px;
  // }
  /deep/.van-checkbox__icon {
    height: 15.5px;
    line-height: 15.5px;
  }
  p {
    color: #fc6f0c;
  }
}
.protocol-content {
  font-size: 20px;
  margin-top: 35px;
  text-align: center;
}
</style>
